export default __webpack_public_path__ + "static/media/image-3.f3b561cc.png";